import moment from 'moment';
import 'moment/locale/ja';
/**
 * Localized instance for moment please see link below
 * https://github.com/moment/moment/issues/1875#issuecomment-263220119
 */

moment.locale('en');

export default moment;
